import __request__ from "routing/request";
export function cycle() {
  return __request__("POST", "/cluster/deflector/cycle", null, {}, {
    "Accept": ["application/json"]
  });
}
export function cycleByindexSetId(indexSetId) {
  return __request__("POST", `/cluster/deflector/${indexSetId}/cycle`, null, {}, {
    "Accept": ["application/json"]
  });
}
